import type { FieldErrors, FieldValues, Resolver } from 'react-hook-form'
import { z } from 'zod'

export function zodResolver<T extends z.ZodType<FieldValues>>(
  schema: T,
  t?: (key: string) => string
): Resolver<z.infer<T>> {
  return async (values) => {
    const result = schema.safeParse(values)
    if (result.success) {
      return { values: result.data as z.infer<T>, errors: {} }
    }
    const errors: Record<string, { type: string; message: string }> = {}
    for (const issue of result.error.issues) {
      const path = issue.path.join('.')
      if (path && !errors[path]) {
        const message = t ? t(issue.message) : issue.message
        errors[path] = { type: issue.code, message }
      }
    }
    return { values: {}, errors: errors as FieldErrors<z.infer<T>> }
  }
}
